"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Box = void 0;

var _tokens = require("@superlogica/foundation/tokens");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var Box = _styledComponents.default.span.withConfig({
  componentId: "sc-12258du-0"
})(["text-align:center;display:inline-block;vertical-align:middle;transition:all 0.1s ease;font-style:normal;", ""], function (_ref) {
  var appearance = _ref.appearance,
      size = _ref.size,
      theme = _ref.theme;
  return "\n    ".concat(appearance, "\n    font-family: ").concat(theme.fonts.default, ", sans-serif;\n    font-size: ").concat(size.label.fontSize, "px;\n    font-weight:").concat(size.label.fontWeight, ";\n    letter-spacing: ").concat(size.label.letterSpacing, ";\n    line-height: ").concat(size.label.lineHeight, "px;\n    padding-top: ").concat(size.padding.top, "px;\n    padding-right: ").concat(size.padding.right, "px;\n    padding-bottom: ").concat(size.padding.bottom, "px;\n    padding-left: ").concat(size.padding.left, "px;\n    border-radius: ").concat(_tokens.borderRadius.pill, ";\n    min-width: ").concat(size.width, "px;\n    height: ").concat(size.height, "px;\n    &:empty{\n      min-width: ").concat(size.width / 2, "px;\n      height: ").concat(size.height / 2, "px;\n    }\n  ");
});

exports.Box = Box;